import {FC} from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Box from "@mui/material/Box";


const ProfileBlocked: FC = () => (
    <Box sx={{textAlign: 'center', padding: '2rem'}}>
        <LockOutlinedIcon sx={{fontSize: '12rem'}}/>
        <p>
            Aangezien de proefperiode van deze herinneringspagina is verlopen, is deze nu geblokkeerd.
        </p>
        <p>
            Ga naar "Pagina activeren" in het menu om de pagina te activeren en deze weer te kunnen gebruiken.
        </p>
    </Box>
)

export default ProfileBlocked
